import React from "react";
import { useTranslation } from 'react-i18next';
import { AuthLayout } from '../components/AuthLayout';
import { ConfirmationSentForm } from '../components/ConfirmationSentForm';

export const ConfirmationSent = () => {
  const { t } = useTranslation();

  return (
    <AuthLayout title={t('website:auth.confirmationSent.pageTitle')}>
      <ConfirmationSentForm deactivated={true} standalone />
    </AuthLayout>
  );
};
